import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInstagram, FiFacebook, FiMail, FiPhone, FiMapPin } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-brand-blue text-white" id="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16">
          {/* Brand Column */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-4 mb-8">
              <img 
                src="https://i.imghippo.com/files/DqZX5957Q.png" 
                alt="Castello SRL Logo" 
                className="h-16 w-auto brightness-0 invert" 
              />
              <div className="flex flex-col">
                <h3 className="text-3xl font-bold text-white leading-none">
                  Castello <span className="text-brand-gold">SRL</span>
                </h3>
                <span className="text-[10px] uppercase tracking-[0.3em] text-brand-silver font-bold mt-1">
                  Property Management
                </span>
              </div>
            </div>
            <p className="text-brand-silver mb-10 max-w-md leading-relaxed text-lg font-light">
              La prima scelta per la gestione professionale di immobili di prestigio. Tecnologia, trasparenza e rendimenti superiori alla media di mercato.
            </p>
            <div className="flex space-x-6">
              <a 
                href="https://www.instagram.com/castellomanagement.it/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white/10 p-4 rounded-xl hover:bg-brand-gold transition-all group"
                aria-label="Seguici su Instagram"
              >
                <SafeIcon icon={FiInstagram} className="h-6 w-6 group-hover:scale-110 transition-transform" />
              </a>
              <a 
                href="#" 
                className="bg-white/10 p-4 rounded-xl hover:bg-brand-gold transition-all group"
                aria-label="Seguici su Facebook"
              >
                <SafeIcon icon={FiFacebook} className="h-6 w-6 group-hover:scale-110 transition-transform" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xl font-bold mb-8 text-brand-gold uppercase tracking-widest text-sm">Navigazione</h4>
            <ul className="space-y-4">
              <li><Link to="/servizi" className="text-brand-silver hover:text-white transition-colors">Servizi Istituzionali</Link></li>
              <li><Link to="/simulatore" className="text-brand-silver hover:text-white transition-colors">Simulatore ROI</Link></li>
              <li><Link to="/chi-siamo" className="text-brand-silver hover:text-white transition-colors">Vision & Team</Link></li>
              <li><Link to="/privacy-policy" className="text-brand-silver hover:text-white transition-colors text-sm opacity-70">Privacy & Compliance</Link></li>
            </ul>
          </div>

          {/* Contacts */}
          <div>
            <h4 className="text-xl font-bold mb-8 text-brand-gold uppercase tracking-widest text-sm">Contatti HQ</h4>
            <div className="space-y-6">
              <div className="flex items-start space-x-4 text-brand-silver">
                <SafeIcon icon={FiMail} className="h-6 w-6 text-brand-gold mt-1" />
                <a href="mailto:info@castellomanagement.it" className="hover:text-white text-lg font-medium">
                  info@castellomanagement.it
                </a>
              </div>
              <div className="flex items-start space-x-4 text-brand-silver">
                <SafeIcon icon={FiPhone} className="h-6 w-6 text-brand-gold mt-1" />
                <a href="tel:+393358344557" className="hover:text-white text-lg font-medium">
                  +39 335 834 4557
                </a>
              </div>
              <div className="flex items-start space-x-4 text-brand-silver">
                <SafeIcon icon={FiMapPin} className="h-6 w-6 text-brand-gold mt-1" />
                <span className="text-lg font-medium leading-tight">Via Ravizza 14<br/>20149 Milano</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-20 pt-10 text-center">
          <p className="text-brand-silver text-sm font-medium">
            © 2025 Castello SRL - P.IVA 10257200963. <br className="md:hidden" />
            <span className="mx-2 hidden md:inline">|</span> Sviluppato per l'eccellenza nel Property Management.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;